import {
  openBillingPaywall,
  setBillingEntitlement,
  setBillingPortalUrl,
} from "store/billing/billingSlice"
import type { StripeEntitlementResponse, StripeErrorResponse } from "store/billing/types"
import { store } from "store/store"
import { removeProtectedMerchantQueryData } from "providers/queryClient"

export const BILLING_PAYWALL_CODES = new Set([
  "billing_access_required",
  "billing_portal_required",
  "billing_trial_canceled",
])

export const toDeniedBillingEntitlement = (
  data: StripeErrorResponse
): StripeEntitlementResponse => {
  const deniedEntitlement = data.entitlement
  const requiresPortal =
    data.code === "billing_portal_required" ||
    deniedEntitlement?.requiresPortal === true ||
    Boolean(data.portalUrl)

  return {
    ...deniedEntitlement,
    accessState:
      deniedEntitlement?.accessState ??
      data.accessState ??
      (requiresPortal ? "portal_required" : "locked"),
    cancelAtPeriodEnd: deniedEntitlement?.cancelAtPeriodEnd ?? false,
    entitled: false,
    entitlementStatus: deniedEntitlement?.entitlementStatus ?? data.code,
    lockReason:
      deniedEntitlement?.lockReason ??
      data.lockReason ??
      (data.code === "billing_trial_canceled" ? "trial_canceled" : undefined),
    requiresPortal,
  }
}

export const syncBillingEntitlement = (entitlement: StripeEntitlementResponse | null) => {
  if (entitlement && !entitlement.entitled) removeProtectedMerchantQueryData()
  store.dispatch(setBillingEntitlement(entitlement))
}

export const syncBillingUnavailableState = () => {
  removeProtectedMerchantQueryData()
}

export const syncBillingDenyState = (
  data: StripeErrorResponse,
  options?: {
    openPaywall?: boolean
  }
) => {
  syncBillingEntitlement(toDeniedBillingEntitlement(data))
  if (data.portalUrl) store.dispatch(setBillingPortalUrl(data.portalUrl))
  if (options?.openPaywall !== false) store.dispatch(openBillingPaywall())
}

export const isBillingPaywallError = (
  data: StripeErrorResponse | null
): data is StripeErrorResponse => Boolean(data?.code && BILLING_PAYWALL_CODES.has(data.code))
